// extracted by mini-css-extract-plugin
export default {"mCard":"Ao-z","image":"Bo-z","imageNoBackground":"Co-z","imageHasCategory":"Do-z","fullWidth":"Eo-z"};